import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import loadable from "@loadable/component";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import APIS from "../../constant/EndPoint";
import useDeleteHook from "../../customHooks/useDeleteHook";
import usePostHook from "../../customHooks/usePostHook";
import { queryClient } from "../../router/ConsignmentRouter";
import { orderRemarksValidationForm } from "../../utils/validationSchemas";

const OrderListComponent = loadable(
  () => import("../../components/Consignment/ConsignmentList")
);

export const OrderList = () => {
  const [openDeletePopup, setOpenDeletePopup] = useState(false);

  const commentMethods = useForm({
    defaultValues: {
      comment: null,
    },
    resolver: yupResolver(orderRemarksValidationForm),
  });

  const { mutateAsync, isLoading } = useDeleteHook({
    queryKey: ["order"],
  });

  const handleDelete = async (values, id: any, setError, clearErrors) => {
    const comment = values?.comment;
    if (!comment) {
      return setError("comment", {
        type: "validate",
        message: "Comment is required",
      });
    }
    const deleteURL = `${APIS.ORDER}${id}/`;
    try {
      const res = await mutateAsync({
        url: deleteURL,
        formData: {
          comment: comment,
        },
        setError,
        clearErrors,
      });
      if (res?.status === 200) {
        queryClient.refetchQueries();
        setOpenDeletePopup(false);
      }
    } catch (e) {
      if (e instanceof Error) toast.error(e.message);
    }
  };

  return (
    <>
      <OrderListComponent
        handleDelete={handleDelete}
        isLoading={isLoading}
        openDeletePopup={openDeletePopup}
        setOpenDeletePopup={setOpenDeletePopup}
        commentMethods={commentMethods}
        resetComment={() => commentMethods.reset({ comment: null })}
      />
    </>
  );
};
